import Route from 'cio/routes/base';
import LoginController from 'cio/pods/login/controller';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

export default class LoginChooseAccount extends Route {
  @service analytics!: AnalyticsService;

  redirect() {
    let { googleOneClickChooseUserEntries } = this.controllerFor('login') as LoginController;

    if (!googleOneClickChooseUserEntries) {
      return this.router.transitionTo('login');
    }

    return;
  }

  activate() {
    let { googleOneClickChooseUserEntries } = this.controllerFor('login') as LoginController;

    this.analytics.track('user', 'sign_in_choose_user_list_viewed', {
      usersCount: googleOneClickChooseUserEntries!.length,
    });
  }
}
